module.exports = __webpack_public_path__ + "img/23.c913e693.webp";